import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var MdmModal = function MdmModal() {
  return import(
  /* webpackChunkName: "modal" */
  '~/components/atoms/Global/MdmModal.vue');
};

export default {
  name: 'YoutubeModal',
  components: {
    MdmModal: MdmModal
  },
  props: {
    showYoutubeModal: {
      type: Boolean,
      required: false
    },
    src: {
      type: Array,
      required: true
    }
  }
};